// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateEmployeeContractMutationVariables = Types.Exact<{
  input: Types.CreateEmployeeContractInput;
}>;

export type CreateEmployeeContractMutation = { __typename?: 'Mutation' } & {
  createEmployeeContract: { __typename?: 'EmployeeContractOutput' } & Pick<Types.EmployeeContractOutput, 'id'>;
};

export const CreateEmployeeContractDocument = /*#__PURE__*/ gql`
    mutation createEmployeeContract($input: CreateEmployeeContractInput!) {
  createEmployeeContract(input: $input) {
    id
  }
}
    `;
export type CreateEmployeeContractMutationFn = Apollo.MutationFunction<
  CreateEmployeeContractMutation,
  CreateEmployeeContractMutationVariables
>;

/**
 * __useCreateEmployeeContractMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeContractMutation, { data, loading, error }] = useCreateEmployeeContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeContractMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEmployeeContractMutation, CreateEmployeeContractMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEmployeeContractMutation, CreateEmployeeContractMutationVariables>(
    CreateEmployeeContractDocument,
    options,
  );
}
export type CreateEmployeeContractMutationHookResult = ReturnType<typeof useCreateEmployeeContractMutation>;
export type CreateEmployeeContractMutationOptions = Apollo.BaseMutationOptions<
  CreateEmployeeContractMutation,
  CreateEmployeeContractMutationVariables
>;
